<template>
  <v-dialog v-model="valueProxy" width="90%" max-width="400px">
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <v-card min-height="250">
        <v-card-title>
          <span class="mainTitle" style="font-size: 20px">
            {{ 'Discount' }}
          </span>
          <v-spacer />
          <v-btn icon @click="valueProxy = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col>
                <v-btn-toggle
                  class="full-width"
                  v-model="discount.type"
                  color="primary"
                  mandatory
                  tile
                >
                  <v-btn style="width: 50%" :value="productOrderDiscountType.byValue">Value</v-btn>
                  <v-btn style="width: 50%" :value="productOrderDiscountType.byPercentage"
                    >Percentage</v-btn
                  >
                </v-btn-toggle>
              </v-col>
            </v-row>
            <v-row align="baseline">
              <v-col cols="4"> Amount </v-col>
              <v-col cols="8">
                <ValidationProvider v-slot="{ errors }" name="Amount">
                  <v-text-field
                    flat
                    outlined
                    :prefix="discount.type === productOrderDiscountType.byValue ? '$' : ''"
                    :suffix="discount.type === productOrderDiscountType.byPercentage ? '% off' : ''"
                    v-model.number="discount.value"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="4"> Remarks </v-col>
              <v-col cols="8">
                <ValidationProvider v-slot="{ errors }" name="Remarks">
                  <v-text-field
                    flat
                    outlined
                    v-model="discount.remarks"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="doClose()">Cacnel</v-btn>
          <v-btn color="primary" @click="confirm()"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { productOrderDiscountType } from '@/data/constants';
import CustomLabel from '@/components/customFormLabel/customLabel';

export default {
  name: 'ProductOrderDiscountDialog',
  components: {
    CustomLabel,
  },
  props: {
    value: {},
    data: {},
  },
  data() {
    return {
      productOrderDiscountType,
      discount: {},
    };
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.discount = Object.assign(
            {},
            {
              type: productOrderDiscountType.byPercentage,
              value: 0,
              remarks: '',
            },
            { ...this.data },
          );
        }
      },
    },
  },
  computed: {
    valueProxy: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  methods: {
    doClose() {
      this.valueProxy = false;
    },
    confirm() {
      this.$emit('confirm', this.discount);
    },
  },
};
</script>

<style lang="scss" scoped></style>
